module.exports = __webpack_public_path__ + "img/pay_03.39ba7613.png";